export default "__VITE_ASSET__103f252e__"